import { __rest } from "tslib";
import * as React from 'react';
const ChevronDownXSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M11.6477665,5.64523352 L12.3548733,6.3523403 L9.06173978,9.64520683 L9.06394957,9.64889487 L8.35684279,10.3560016 L8.35473978,10.3522068 L8.35351599,10.3548733 L7.64640921,9.64776648 L7.64773978,9.64520683 L4.35473978,6.35231361 L5.06184657,5.64520683 L8.35473978,8.93820683 L11.6477665,5.64523352 Z" })));
};
ChevronDownXSmall.displayName = 'ChevronDownXSmall';
export default ChevronDownXSmall;
//# sourceMappingURL=ChevronDownXSmall.js.map